import { useQuery } from '@tanstack/react-query';
import { KimPushPullReportService } from '@/infra/services/kim-pp-report';
import { QUERY_KEYS } from '@/utils/query-keys';

interface GetKimPPParams {
	organization_id: string;
	company_id: string;
	file_id: string;
}

const Service = KimPushPullReportService.getInstance();

export const useGetKimPp = (params: GetKimPPParams) => {
	return useQuery({
		queryKey: [QUERY_KEYS.GET_KIM_PP_REPORT, params],
		queryFn: () => Service.getReport(params),
		enabled: !!params.organization_id && !!params.company_id && !!params.file_id,
		retry: 0
	});
};

